import WechatJSSDK from "wechat-jssdk/dist/client.umd";
import { parseQuery } from "@utils";
import cookie from "@utils/store/cookie";
import store from "@/store";
import request from "@utils/request";

const STATE_KEY = "wx_authorize_state";
const WX_AUTH = "wx_auth";
const BACK_URL = "login_back_url";
const LOGINTYPE = "loginType";
let instance;
let wechatObj;

/**
 * 获取微信sdk配置
 * @returns {*}
 */
function getWechatConfig() {
  let url = location.href.split('#')[0]
  return request.post('/ashx/wxHelper.ashx?action=Sign', {
    url: encodeURIComponent(url)
  }, {login: false});
}

function wechatAuth(code) {
  return request.post('/ashx/wxHelper.ashx?action=User', {
    code
  }, {login: false});
}

export default function wechat() {
  return new Promise((resolve, reject) => {
    if (instance) return resolve(instance);
    getWechatConfig()
      .then(res => {
        console.log('[weixin] wechat getWechatConfig then', res)
        const _wx = WechatJSSDK(res);
        wechatObj = _wx;
        _wx
          .initialize()
          .then(() => {
            console.log('[weixin] wechat then')
            instance = _wx.wx;
            instance.initConfig = res;
            resolve(instance);
          })
          .catch(reject);
      })
      .catch(err => {
        console.log(err);
        reject(err);
      });
  });
}

export function clearAuthStatus() {
  cookie.remove(WX_AUTH);
  cookie.remove(STATE_KEY);
}

export function oAuth() {
  if (cookie.has(WX_AUTH) && store.state.app.token) return true;
  const { code } = parseQuery();
  if (!code) return toAuth();
}

export function auth(code) {
  return new Promise((resolve, reject) => {
    wechatAuth(code)
      .then(data => {
        console.log('[weixin] wechatAuth res', data)
        if (typeof data == 'object' && data.openid) {
          let express_days = 7;// 7天过期
          store.commit("LOGIN", data, express_days);
          cookie.set(WX_AUTH, code, express_days);
          cookie.remove(STATE_KEY);
          resolve();
        } else {
          reject(data)
        }
      })
      .catch(reject);
  });
}

export function toAuth() {
  console.log('[weixin] toAuth start')
  wechat().then(wx => {
    let url = getAuthUrl(wx.initConfig.appId);
    console.log('[weixin] toAuth url', url)
    location.href = url
  });
}

function getAuthUrl(appId) {
  let url = location.href.split('#')[0] + '#/auth';
  const redirect_uri = encodeURIComponent(url);
  const state = encodeURIComponent(
    ("" + Math.random()).split(".")[1] + "authorizestate"
  );
  cookie.set(STATE_KEY, state);
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`;
}

function toPromise(fn, config = {}) {
  return new Promise((resolve, reject) => {
    fn({
      ...config,
      success(res) {
        resolve(res);
      },
      fail(err) {
        reject(err);
      },
      complete(err) {
        reject(err);
      },
      cancel(err) {
        reject(err);
      }
    });
  });
}

export function pay(config) {
  return toPromise(instance.chooseWXPay, config);
}

export function openAddress() {
  return new Promise((resolve, reject) => {
    wechatEvevt("openAddress", {})
      .then(res => {
        console.log(res);
        resolve(res);
      })
      .catch(res => {
        console.log(res);
        if (res.is_ready) {
          res.wx.openAddress({
            fail(res) {
              reject(res);
            },
            success(res) {
              resolve(res);
            }
          });
        } else {
          reject(res);
        }
      });
  });
}

export function openShareAll(config) {
  config || {};
  config.type = config.type == undefined ? "link" : config.type;
  return new Promise(resolve => {
    console.log('to get config');
    getWechatConfig().then(res => {
      wechatObj.signSignature({
        nonceStr: res.nonceStr,
        signature: res.signature,
        timestamp: res.timestamp
      });
      instance = wechatObj.getOriginalWx();
      instance.ready(() => {
        instance.updateAppMessageShareData(config);
        instance.updateTimelineShareData(config);
        resolve();
      });
    });
  });
}
export function scanQRCode(needResult) {
  return new Promise(resolve => {
    wechat().then(res => {
      wechatObj.signSignature({
        nonceStr: res.nonceStr,
        signature: res.signature,
        timestamp: res.timestamp
      });
      instance = wechatObj.getOriginalWx();
      instance.ready(() => {
        console.log('needResult',needResult)
        instance.scanQRCode({
          needResult: needResult, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
            console.log('scan qr code res', res)
            var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
            resolve(result);
          }
        });

      });
    });
  });
}

export function openShareAppMessage(config) {
  instance.updateAppMessageShareData(config);
  instance.onMenuShareAppMessage && instance.onMenuShareAppMessage(config);
}

export function openShareTimeline(config) {
  instance.updateTimelineShareData(config);
  instance.onMenuShareTimeline && instance.onMenuShareTimeline(config);
}

/**
 * 公众号事件
 * @param name 事件名
 * @param config 配置
 * @returns {Promise<unknown>}
 */
export function wechatEvevt(name, config) {
  return new Promise((resolve, reject) => {
    let wx;
    let configDefault = {
      fail(res) {
        console.log(res);
        if (wx) return reject({ is_ready: true, wx: wx });
        getWechatConfig().then(res => {
          wechatObj.signSignature({
            nonceStr: res.nonceStr,
            signature: res.signature,
            timestamp: res.timestamp
          });
          wx = wechatObj.getOriginalWx();
          reject({ is_ready: true, wx: wx });
        });
      },
      success(res) {
        resolve(res);
      }
    };
    Object.assign(configDefault, config);
    if (typeof instance !== "undefined") {
      instance.ready(() => {
        if (typeof name === "object") {
          name.forEach(item => {
            instance[item] && instance[item](configDefault);
          });
        } else instance[name] && instance[name](configDefault);
      });
    } else {
      getWechatConfig().then(res => {
        const _wx = WechatJSSDK(res.data);
        _wx.initialize().then(() => {
          instance = _wx.getOriginalWx();
          instance.ready(() => {
            if (typeof name === "object") {
              name.forEach(item => {
                instance[item] && instance[item](configDefault);
              });
            } else instance[name] && instance[name](configDefault);
          });
        });
      });
    }
  });
}

export function ready() {
  return new Promise(resolve => {
    if (typeof instance !== "undefined") {
      instance.ready(() => {
        resolve(instance);
      });
    } else {
      getWechatConfig().then(res => {
        const _wx = WechatJSSDK(res.data);
        _wx.initialize().then(() => {
          instance = _wx.wx;
          instance.ready(() => {
            resolve(instance);
          });
        });
      });
    }
  });
}



// WEBPACK FOOTER //
// ./src/utils/wechat.js